<template>
  <message>
    <template slot="icon">
      <i class="far fa-calendar-check text-success" style="font-size: 100px" />
    </template>
    <template slot="text">
      <h3 class="text-success p-t-20">{{ $t('honda.repair.success') }}</h3>
    </template>
    <template slot="bottom"> <i class="fa fa-mobile-alt pr-2" />{{ $t('honda.repair.mobile-alert') }} </template>
  </message>
</template>
<script>
import Message from '@/components/dialog/Message'

export default {
  components: {
    Message,
  },
}
</script>
